import { useIntl } from 'react-intl';

const IDS = [
  '6D336AC3-1AB3-43A8-A943-7F1EDB9338E3',
  'C5B72072-699A-44E9-AC29-B377BFFED67D',
  '604238f27222dd4',
  'FE66A053-F853-4024-BD84-1C30C0F6C1ED',
  'f772f7e8226e1695e12d9aff0bdce478996',
  '3BA6D271-2935-4562-B9F0-B96791270321'
];

function ExampleIds() {
  const { formatMessage } = useIntl();

  return (
    <table cellPadding="0" cellSpacing="0" className="deviceIds__fileUpload__table">
      <thead>
        <tr>
          <th>
            {formatMessage({
              defaultMessage: 'Device id',
              id: 'targeting.deviceIds.fileUpload.device'
            })}
          </th>
        </tr>
      </thead>
      <tbody>
        {IDS.map((id: string, index) => (
          <tr key={id}>
            <td>
              {formatMessage({
                defaultMessage: id,
                id: `targeting.deviceIds.fileUpload.items.${index + 1}`
              })}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ExampleIds;
